import { ScrollReveal } from "@/hooks/useScrollReveal";
import { CATALOG_URL } from "@/mocks/site-config";
import Watermark from "@/components/base/Watermark";

const brandFacts = [
  { label: "正式名稱", value: "崧燁文化事業有限公司" },
  { label: "網站簡稱", value: "崧燁文化" },
  { label: "英文名稱", value: "SUNYA" },
  { label: "出版方向", value: "醫療保健、研究與論文相關專業書籍" },
];

export default function AboutSunya() {
  return (
    <section className="min-h-[100svh] flex items-center bg-background-50">
      <Watermark />
      <div className="mx-auto px-6 md:px-10 py-16 md:py-24 max-w-[1120px] w-full">
        <ScrollReveal>
          <div className="flex flex-col lg:flex-row lg:gap-16 mb-14 md:mb-20">
            <div className="lg:w-[30%] flex-shrink-0 mb-6 lg:mb-0">
              <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 font-medium">
                品牌資訊
              </p>
            </div>
            <div className="lg:w-[70%]">
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 leading-tight">
                認識崧燁文化
              </h2>
              <p className="text-sm text-foreground-500 mt-4 leading-relaxed max-w-lg">
                專業知識、醫療保健與研究出版
              </p>
            </div>
          </div>
        </ScrollReveal>

        <div className="lg:ml-[30%] lg:pl-16">
          {/* Key facts grid */}
          <ScrollReveal delay={100}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              {brandFacts.map((fact) => (
                <div
                  key={fact.label}
                  className="bg-background-50 border border-background-200/70 p-4 md:p-5"
                >
                  <p className="text-xs text-foreground-400 mb-1.5 tracking-wide">
                    {fact.label}
                  </p>
                  <p className="text-sm md:text-base text-foreground-900 font-medium">
                    {fact.value}
                  </p>
                </div>
              ))}
            </div>
          </ScrollReveal>

          {/* Brand intro paragraph */}
          <ScrollReveal delay={200}>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-lg mb-6">
              崧燁文化專注於醫療保健、研究與論文相關專業書籍，提供具知識性、研究性與實務參考價值的出版內容。網站呈現崧燁文化的品牌定位、最新發行書籍與相關出版資訊。
            </p>
          </ScrollReveal>

          {/* Relationship with Sonbo */}
          <ScrollReveal delay={300}>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-lg mb-8">
              本品牌委託崧博出版經銷，官方網站由崧博出版製作。委託經銷與網站製作不代表崧燁文化是崧博旗下品牌、子品牌或自有品牌；崧燁文化具有自身獨立的出版定位。
            </p>
          </ScrollReveal>

          {/* Catalog link card */}
          <ScrollReveal delay={400}>
            <div className="bg-background-100 border border-background-200/70 p-5 md:p-6 max-w-lg">
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                完整書名、作者與出版資訊，請前往崧博書籍資料庫查詢。
              </p>
              <a
                href={CATALOG_URL}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="bg-foreground-900 hover:bg-foreground-800 text-white px-6 py-3 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors inline-flex items-center justify-center gap-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground-400 focus-visible:ring-offset-2"
              >
                前往書籍資料庫
                <i className="ri-external-link-line text-sm"></i>
              </a>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}